export default "__VITE_ASSET__DmEketLS__"